import { Box, Button, IconButton, Modal } from '@mui/material';
import PropTypes from 'prop-types';
import JunoButton from './JunoButton';
import CloseIcon from '@mui/icons-material/Close';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#26272B',
    boxShadow: 24,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

const ActionConfirmModal = ({
    open,
    onConfirm,
    onCancel,
    heading,
    subHeading,
    body = () => {},
    loading,
    type,
    actionButtonText = 'confirm',
    customSubHead,
    noDivider,
    showCloseIcon = true,
}) => {
    return (
        <Modal open={open}>
            <Box sx={style}>
                <div
                    className={`relative ${
                        type == 'delete'
                            ? 'shadow-[#E33C31] border-[#E33C31]'
                            : 'border-[#BAC4C8] shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08)] '
                    } w-80 md:w-96 pt-2 dark:bg-[#26272B] bg-[#FFF]  rounded-lg border-t-[3px] inline-flex flex-col justify-start items-center gap-6 overflow-hidden`}>
                    {showCloseIcon && (
                       <div className='absolute top-2 right-2 z-10'>
                         <IconButton onClick={() => onCancel()} aria-label="close">
                            <CloseIcon className="!text-primary" />
                        </IconButton>
                       </div>
                    )}
                    <div className="self-stretch px-6 flex flex-col justify-start items-center gap-6 mt-12">
                        <div className="self-stretch flex flex-col justify-start items-center gap-4">
                            <div
                                className={`${
                                    type == 'delete' ? 'text-[#E33C31]' : 'text-text'
                                } text-center justify-center text-lg font-semibold uppercase leading-7 tracking-tight`}>
                                {heading}
                            </div>
                            <div className="self-stretch text-center justify-center text-profile-text-muted text-sm font-medium uppercase leading-tight w-5/6 m-auto">
                                {customSubHead ? customSubHead() : subHeading}
                            </div>
                        </div>
                        {noDivider ? null : (
                            <div className="self-stretch h-px relative bg-divider-text" />
                        )}
                        {body()}
                    </div>
                    <div className="self-stretch p-6 bg-[#FFFFFF0D] border-t border-divider-text inline-flex justify-center items-center gap-2 w-full">
                        <JunoButton
                            dataE2e="cancel-btn"
                            onClick={() => onCancel()}
                            disabled={loading}
                            className={'grow-1 !font-semibold !text-sm !leading-tight'}
                            type="secondary">
                            cancel
                        </JunoButton>

                        <JunoButton
                            dataE2e={loading ? 'processing' : actionButtonText}
                            type="error"
                            className={'grow-1 !font-semibold !text-sm !leading-tight'}
                            disabled={loading}
                            onClick={() => onConfirm()}>
                            {loading ? 'processing' : actionButtonText}
                        </JunoButton>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

ActionConfirmModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string,
    body: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    loading: PropTypes.bool,
    type: PropTypes.oneOf(['delete', 'default']),
    actionButtonText: PropTypes.string,
};

export default ActionConfirmModal;
